/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import { Form } from '@unform/web';
import { FiFilter } from 'react-icons/fi';
import Swal from 'sweetalert2';
import {
  FaChevronLeft,
  FaChevronRight,
  FaEllipsisH,
  FaEdit,
  FaMoneyBill,
} from 'react-icons/fa';
import Pagination from 'react-paginate';
import {
  Button,
  Card,
  Col,
  Row,
  Table,
  UncontrolledCollapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { Input, Select } from '../../components/unform/index';
import api from '../../services/api';
import { Translator } from '../../components/i18n';

function GestaoColeta() {
  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const formRef = useRef();
  const formRefEdit = useRef();

  const [coletas, setColetas] = useState([]);
  const [coletaSelected, setColetaSelected] = useState(null);
  const [filtro, setFiltro] = useState({});
  const [movimentacaoFinanceiraIds, setMovimentacaoFincaneiraIds] =
    useState(null);

  const [modal, setModal] = useState(false);
  const [modalEdit, setModaledit] = useState(false);

  const toggle = () => setModal(!modal);
  const toggleEdit = () => setModaledit(!modalEdit);

  let timeoutConsulta;
  function filtrarConsulta(e, value) {
    setFiltro({ ...filtro, [value]: e, page: 1 });
  }

  const debounceConsulta = async (body, value) =>
    new Promise((resolve) => {
      clearTimeout(timeoutConsulta);

      timeoutConsulta = setTimeout(() => {
        resolve(filtrarConsulta(body, value));
      }, 500);
    });

  async function getColetas() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const params = Object.keys(filtro)
        .map((e) => {
          if (e === 'page') {
            if (Number.isNaN(filtro[e])) {
              return `${e}=${1}`;
            }
          }
          return `${e}=${filtro[e]}`;
        })
        .join('&');

      const { data } = await api.get(`/coletas?${params}`);

      setColetas(data);
      window.scrollTo(0, 0);

      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  }

  useEffect(() => {
    getColetas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  const handleEditColeta = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRefEdit.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await api.put(`/coleta/${coletaSelected?.id}`, data);
        toast.success(dadosSalvosSucesso);
        setColetaSelected(null);
        getColetas();
        toggleEdit();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const getInfosColeta = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/coleta/${id}`);

      setColetaSelected(data);
      toggleEdit();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  async function handleCriarMovimentacao({
    idColeta,
    idFazenda,
    idSafra,
    idTalhao,
  }) {
    setMovimentacaoFincaneiraIds({
      idColeta,
      idFazenda,
      idSafra,
      idTalhao,
    });
    toggle();
  }

  async function handleSumbitCriarMovimentacao(data) {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f] && f !== 'descricao' && f !== 'data_pagamento') {
        errors[f] = obrigatorio;
      }
    });

    formRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        data.id_fazenda = movimentacaoFinanceiraIds?.idFazenda;
        data.id_safra = movimentacaoFinanceiraIds?.idSafra;
        data.id_talhao = movimentacaoFinanceiraIds?.idTalhao;
        data.id = movimentacaoFinanceiraIds?.idColeta;
        await api.post('/movimentacao/coleta', data);
        toast.success(dadosSalvosSucesso);
        setMovimentacaoFincaneiraIds(null);
        getColetas();
        toggle();
        Swal.close();
      } catch (err) {
        toast.error(erroSalvarDados);
        Swal.close();
      }
    }
  }

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">
            <Translator path="gestaocoleta.label" />
          </h4>
        </Col>
      </Row>
      <Card>
        <div className="p-3 justify-content-between d-flex align-items-center">
          <Col lg={6}>
            <h6 className="txt-muted">
              <Translator path="excecoes.totalregistros" /> {coletas.total}
            </h6>
          </Col>
          <Col>
            <Button
              color="muted"
              id="toggler"
              className="d-flex align-items-center"
            >
              <FiFilter size={20} />
              &nbsp;&nbsp;
              <Translator path="gestaocoleta.filtro" />
            </Button>
          </Col>
          <div className="d-flex justify-content-center" />
        </div>
        <div className="filter-collapse px-3 ">
          <UncontrolledCollapse toggler="#toggler" className="pb-3">
            <Row>
              <Col lg={3}>
                <Label>
                  <Translator path="gestaocoleta.filtro.fazenda" />
                </Label>
                <input
                  onChange={(e) => debounceConsulta(e.target.value, 'fazenda')}
                  className="form-control"
                />
              </Col>
              <Col lg={3}>
                <Label>
                  <Translator path="gestaocoleta.filtro.safra" />
                </Label>
                <input
                  onChange={(e) => debounceConsulta(e.target.value, 'safra')}
                  className="form-control"
                />
              </Col>
              <Col lg={2}>
                <Label>
                  <Translator path="gestaocoleta.filtro.talhao" />
                </Label>
                <input
                  onChange={(e) => debounceConsulta(e.target.value, 'talhao')}
                  className="form-control"
                />
              </Col>
              <Col lg={2}>
                <Label>
                  <Translator path="gestaocoleta.filtro.statuscoleta" />
                </Label>
                <select
                  onChange={(e) =>
                    debounceConsulta(e.target.value, 'status_coleta')
                  }
                  className="form-control"
                >
                  <option value="">
                    <Translator path="gestaocoleta.filtro.statuscoleta" />
                  </option>
                  <option>
                    <Translator path="gestaocoleta.filtro.statuscoleta.coletado" />
                  </option>
                  <option>
                    <Translator path="gestaocoleta.filtro.statuscoleta.enviado" />
                  </option>
                  <option>
                    <Translator path="gestaocoleta.filtro.statuscoleta.completo" />
                  </option>
                </select>
              </Col>
              <Col lg={2}>
                <Label>
                  <Translator path="gestaocoleta.filtro.statuspagamento" />
                </Label>
                <select
                  onChange={(e) =>
                    debounceConsulta(e.target.value, 'status_pagamento')
                  }
                  className="form-control"
                  placeholder="Status Coleta"
                >
                  <option value="">
                    <Translator path="gestaocoleta.filtro.statuspagamento" />
                  </option>
                  <option>
                    <Translator path="gestaocoleta.filtro.statuspagamento.aberto" />
                  </option>
                  <option>
                    <Translator path="gestaocoleta.filtro.statuspagamento.provisionado" />
                  </option>
                  <option>
                    <Translator path="gestaocoleta.filtro.statuspagamento.pago" />
                  </option>
                </select>
              </Col>
            </Row>
          </UncontrolledCollapse>
        </div>

        <Table responsive>
          <thead>
            <tr>
              <th>
                <Translator path="gestaocoleta.fazenda" />
              </th>
              <th>
                <Translator path="gestaocoleta.safra" />
              </th>
              <th>
                <Translator path="gestaocoleta.talhao" />
              </th>
              <th className="text-center">
                <Translator path="gestaocoleta.qtdepc" />
              </th>
              <th className="text-center">
                <Translator path="gestaocoleta.statuscoleta" />
              </th>
              <th className="text-center">
                <Translator path="gestaocoleta.statuspagamento" />
              </th>
              <th className="text-center">
                <Translator path="gestaocoleta.acao" />
              </th>
            </tr>
          </thead>
          <tbody>
            {coletas?.coletas?.length ? (
              coletas.coletas?.map((c) => (
                <tr key={c?.id}>
                  <td>{c?.Fazenda?.label}</td>
                  <td>{c?.Safra?.label}</td>
                  <td>{c?.Talhao?.label}</td>
                  <td className="text-center">{c?.quantidade_pc}</td>
                  <td className="text-center">{c?.status_coleta}</td>
                  <td className="text-center">{c?.status_pagamento}</td>
                  <td className="text-center">
                    <UncontrolledDropdown size="xs">
                      <DropdownToggle color="link link-gray" size="xs">
                        <FaEllipsisH size="1.3em" color="#43b02a" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        {c?.status_pagamento === 'Aberto' && (
                          <DropdownItem
                            onClick={() =>
                              handleCriarMovimentacao({
                                idColeta: c?.id,
                                idFazenda: c?.Fazenda?.value,
                                idSafra: c?.Safra?.value,
                                idTalhao: c?.Talhao?.value,
                              })
                            }
                            size="xs"
                          >
                            <FaMoneyBill className="mr-1" size={20} />
                            <Translator path="gestaocoleta.editarcoleta.criarmovimentacao" />
                          </DropdownItem>
                        )}
                        <DropdownItem
                          onClick={() => getInfosColeta(c?.id)}
                          size="xs"
                        >
                          <FaEdit className="mr-1" size={20} />
                          <Translator path="gestaocoleta.acao.editarcoleta" />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>
                  <Translator path="semregistros" />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination
          nextLabel={<FaChevronRight />}
          previousLabel={<FaChevronLeft />}
          pageCount={coletas.pages || 1}
          onPageChange={({ selected }) =>
            setFiltro({ ...filtro, page: selected + 1 })
          }
          initialPage={0}
          containerClassName="pagination justify-end mr-1"
          activeClassName="active"
        />
      </Card>

      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>
          <Translator path="financeirolaboratorio.label" />
        </ModalHeader>
        <Form
          ref={formRef}
          onSubmit={(data) => handleSumbitCriarMovimentacao(data)}
        >
          <ModalBody>
            <Row>
              <Col lg={12}>
                <Input
                  name="descricao"
                  label={
                    <Translator path="financeirolaboratorio.editar.descricao" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={8}>
                <Input
                  name="valor"
                  label={<Translator path="financeirolaboratorio.valor" />}
                  className="form-control"
                  type="number"
                />
              </Col>
              <Col lg={4}>
                <Select
                  label={
                    <Translator path="financeirolaboratorio.editar.moeda" />
                  }
                  className="form-control"
                  name="moeda"
                  data={[
                    {
                      label: '$',
                      value: '$',
                    },
                    {
                      label: '$b',
                      value: '$b',
                    },
                    {
                      label: '€',
                      value: '€',
                    },
                    {
                      label: 'R$',
                      value: 'R$',
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="data_provisionamento"
                  label={
                    <Translator path="financeirolaboratorio.editar.provisionamento" />
                  }
                  className="form-control"
                  type="date"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="data_pagamento"
                  label={
                    <Translator path="financeirolaboratorio.editar.pagamento" />
                  }
                  className="form-control"
                  type="date"
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalEdit} toggle={toggleEdit} size="sm">
        <ModalHeader toggle={toggleEdit}>
          <Translator path="pontos" />
        </ModalHeader>
        <Form ref={formRefEdit} onSubmit={(data) => handleEditColeta(data)}>
          <ModalBody>
            <Row>
              <Col lg={12}>
                <Input
                  name="quantidade_pc"
                  label={<Translator path="gestaocoleta.qtdepc" />}
                  className="form-control"
                  defaultValue={coletaSelected?.quantidade_pc}
                  type="number"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Select
                  label={<Translator path="gestaocoleta.statuscoleta" />}
                  className="form-control"
                  name="status_coleta"
                  defaultValue={coletaSelected?.status_coleta}
                  data={[
                    {
                      label: Translator({
                        path: 'gestaocoleta.filtro.statuscoleta.coletado',
                      }),
                      value: 'Coletado',
                    },
                    {
                      label: Translator({
                        path: 'gestaocoleta.filtro.statuscoleta.enviado',
                      }),
                      value: 'Enviado para análise',
                    },
                    {
                      label: Translator({
                        path: 'gestaocoleta.filtro.statuscoleta.completo',
                      }),
                      value: 'Análise completa',
                    },
                  ]}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default GestaoColeta;
